import styles from './ProductHero.module.css';

export default function ProductHero() {
  return (
    <section className={styles.hero}>
      <div className={styles.inner}>
        <div className={styles.copy}>
          <span className={styles.eyebrow}>Product</span>
          <h1 className={styles.headline}>One chat. Every workflow your pipeline needs.</h1>
          <p className={styles.sub}>
            Tell your agents what you need in plain English. The Hunter finds it, the
            Verifier checks it across every workflow below.
          </p>
        </div>

        {/* Decorative brand mascot - sits beside the content on desktop, hidden on mobile */}
        <div className={styles.mascotWrap} aria-hidden="true">
          <img
            className={styles.mascot}
            src={`${process.env.PUBLIC_URL}/team/RepBuddy.png`}
            alt=""
          />
        </div>
      </div>
    </section>
  );
}
